// Angular
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, RouterLink } from '@angular/router';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

// External Libraries
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

// App Services
import { CatalogService } from '@components/catalog/catalog.service';
import { AppConfigService } from '@core/services/config/app-config.service';

// App Directives & Pipes
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';
import { UpperCasePipe } from '@angular/common';
import { KeyValuePipe } from '@angular/common';

// Models & Interfaces
import { CompanyData } from 'src/app/core/models/corporate-data.interface';

// Components
import { DomainSwitcherComponent } from './domain-switcher/domain-switcher.component';
import { CouriersLogosComponent } from './couriers-logos/couriers-logos.component';
import { PaymentMethodComponent } from '@components/shared/payment-method/payment-method.component';
import { NewsletterFormComponent } from '@components/shared/newsletter-form/newsletter-form.component';

// Other
import { Log } from '@core/services/config/app-config.service';
import { take } from 'rxjs';
import { IubendaService } from 'src/app/services/gdpr/iubenda.service';
import { IubendaLinkComponent } from '@components/shared/iubenda/iubenda-link.component';

export interface PaymentMethod {
    id: string;
    name: string;
    img: string;
}

@Component({
    selector: 'app-footer',
    imports: [
        FontAwesomeModule,
        DomainSwitcherComponent,
        CouriersLogosComponent,
        KeyValuePipe,
        NewsletterFormComponent,
        PaymentMethodComponent,
        RouterLink,
        TranslatePipe,
        IubendaLinkComponent
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

    // ==========================================
    // SERVICES
    // ==========================================
    private catalogService = inject(CatalogService);
    private appConfig = inject(AppConfigService);
    private iubendaService = inject(IubendaService);

    // ==========================================
    // ICONS
    // ==========================================
    public faPhone = faPhone;
    public faEnvelope = faEnvelope;
    public faWhatsapp = faWhatsapp;
    public faInstagram = faInstagram;
    public faFacebookF = faFacebookF;
    public faNostriStore = faLocationDot;

    // ==========================================
    // DATA PROPERTIES
    // ==========================================
    public allCategories: any[] = [];
    public company_data: CompanyData = this.appConfig.getCompanyData();
    public company_logo_url: string = this.appConfig.imagePathLogos();
    public company_email: string = this.getCompanyEmail();

    private getCompanyEmail(): string {
        const domain = this.appConfig.domain();
        
        let email = 'info@emporio-elettrico.' + domain; // default

        if (domain.endsWith('fr')) {
            return 'contact@emporio-elettrico.fr';
        }
        return `${email}`;
    }


    // ==========================================
    // LIFECYCLE HOOKS
    // ==========================================
    ngOnInit() {

        this.catalogService.getAllCategories().pipe(take(1)).subscribe((response) => {
            this.allCategories = response;
        })

        this.checkBlog();

        // this.iubendaService.injectPopUpPrivacyScript();
    }

    //valuta se il valore corrente della key sia un oggetto
    isObject(value: any): boolean {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    public flagBlog:boolean = false;

    checkBlog(){
    
        if(this.appConfig.lang()=='fr'||this.appConfig.lang()=='it'){
            this.flagBlog= true;
        }
    
    }

    public acquisto_intelligente: PaymentMethod = {
        id: 'acquisto-intelligente',
        name: 'Acquisto Intelligente',
        img: `${this.appConfig.imagePathPaymentsMethod()}acquisto-intelligente.png`
    }
}
